export default __webpack_public_path__ + "static/media/usdc.c6156840.svg";